'use client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import type { Member } from '../../types/member';

import { HtmlDescription } from '../ui/html-description';

export function AboutMembers({ members }: { members: Member[] }) {
  const { t } = useTranslations();

  return (
    <div className="flex w-full flex-col items-start justify-start gap-6 sm:gap-8 lg:gap-12">
      <h3 className="text-2xl font-bold text-primary sm:text-3xl">{t('text3126')}</h3>
      <div className="grid w-full grid-cols-1 gap-6 sm:grid-cols-2">
        {members.slice(0, 1).map(member => (
          <div
            key={member.id}
            className="flex w-full items-start justify-start gap-4 sm:gap-5 lg:gap-6"
          >
            <div className="flex w-full flex-col items-start justify-start gap-2">
              <div className="flex w-full flex-col gap-1">
                <h4 className="text-sm font-bold text-primary sm:text-base">
                  {member.name} {member.surname}
                </h4>
                <span className="text-sm font-bold text-secondary sm:text-base">{member.role}</span>
              </div>
              <HtmlDescription content={member.description} className="w-full" color="primary" />
            </div>
          </div>
        ))}
        <div className="col-span-1 h-[40px] w-full" />
        {members.slice(1).map(member => (
          <div
            key={member.id}
            className="flex w-full items-start justify-start gap-4 sm:gap-5 lg:gap-6"
          >
            <div className="flex w-full flex-col items-start justify-start gap-2">
              <div className="flex w-full flex-col gap-1">
                <h4 className="text-sm font-bold text-primary sm:text-base">
                  {member.name} {member.surname}
                </h4>
                <span className="text-sm font-bold text-secondary sm:text-base">{member.role}</span>
              </div>
              <HtmlDescription content={member.description} className="w-full" color="primary" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
